import { DialogStepSchema } from '@feedyou/schema'
import { Mutable } from '@feedyou/utils'
import { Action, actionTypes } from './actions'

export function dialogReducer(step: Mutable<DialogStepSchema>, action: Action) {
  switch (action.type) {
    case actionTypes.SET_DIALOG:
      return { ...step, dialog: action.payload.dialog.id }

    default:
      return step
  }
}
